import { useTranslation } from "react-i18next";
import { generatePath, useNavigate } from "react-router";

import GaiaPageComponent from "~/modules/app/components/GaiaPageComponent";
import GaiaPageLayoutColumn from "~/modules/app/components/GaiaPageLayoutColumn";
import { RESEARCH_TYPE_LIST_PATH } from "~/modules/settings/constants";

import useSettingsResearchTypeCreateRoute_Create from "./api/useSettingsResearchTypeCreateRoute_Create";
import ResearchTypeCreateForm, { ResearchTypeCreateFormInputs } from "./components/ResearchTypeCreateForm";

export default function SettingsResearchTypeCreateRoute() {
    const { t } = useTranslation("researchType");

    const navigate = useNavigate();

    const { createResearchType, error } = useSettingsResearchTypeCreateRoute_Create();

    const handleSubmit = async (data: ResearchTypeCreateFormInputs) => {
        const researchType = await createResearchType(data);
        if (researchType) {
            navigate(generatePath(RESEARCH_TYPE_LIST_PATH));
        }
    };

    return (
        <GaiaPageLayoutColumn>
            <GaiaPageComponent title={t("settingsResearchTypeCreateRoute.title")}>
                <ResearchTypeCreateForm onSubmit={handleSubmit} error={error} />
            </GaiaPageComponent>
        </GaiaPageLayoutColumn>
    );
}
